import { Cross2Icon } from "@radix-ui/react-icons";
import { forwardRef } from "react";
import { Button } from "./Button";
export var ClosePanelButton = forwardRef(function ClosePanelButton(_a, ref) {
    var onClose = _a.onClose, className = _a.className;
    return (<Button ref={ref} onClick={onClose} aria-label="Close panel" data-testid="close-panel-button" className={className} icon={<Cross2Icon aria-hidden="true"/>} variant="neutral" inline size="xs"/>);
});
